import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import s from "./PaymentDetailTag.module.scss";

const getStyle = (status) => {
  switch (status) {
    case "NONE":
    case "CLOSED":
    case "CLOSE":
      return "grey";
    case "OPEN":
      return "white";
    case "SUCCESS":
    case "SETTLED":
    case "AUTHORIZED":
      return "green";
    case "VOIDED":
    case "REVERSED":
    case "PARTIALLY_REFUNDED":
    case "REFUNDED":
      return "orange";
    case "DECLINED":
    case "TIMEOUT":
    case "CANCELLED":
      return "red";
    default:
      return "grey";
  }
};

const PaymentDetailTag = ({ status }) => {
  const { t } = useTranslation();

  return (
    <div className={`${s["tag"]} ${s[getStyle(status)]}`}>
      <Typography variant="content-m-semibold">
        {t(status ?? "") ?? status?.replace("_", " ")}
      </Typography>
    </div>
  );
};

export default PaymentDetailTag;
